<template>
  <div id="app">
    <head-bar></head-bar>
    <!-- banner图 -->
    <img :src="banner" alt="" />
    <!-- :style="{ width: bannerWidth }" -->
    <!-- 服务台和CDS入口，搜索区域 -->
    <input-out></input-out>
    <keep-alive include="HomePage">
      <router-view class="main-body"></router-view>
    </keep-alive>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeadBar from './components/HeadBar.vue'
import FooterBar from './components/FooterBar.vue'
// import banner from '@/assets/banner.png'
import banner from '@/assets/zu23.png'
import InputOut from './components/InputOut.vue'
export default {
  name: 'App',
  components: { HeadBar, FooterBar, InputOut },
  data() {
    return {
      banner,
      bannerWidth: '100%'
    }
  },
  created() {
    // window.onresize = () => {
    // this.$nextTick(() => {
    //   this.bannerWidth = document.body.clientWidth + 'px';
    // })
    // }
    console.log("项目启动，查看环境变量")
    console.table(process.env)
  }
}
</script>

<style lang="less" scoped>
#app {
  min-width: 1300px;
  width: 100%;
  // width: 1900px;
  // width: 100vw;
  overflow: auto;
  & > img {
    // width: 100%;
    width: 1300px;
    // width: 100vw;
    // width: 1270px;
    // margin:auto;
    // min-width: 1270px;
    display: block;
    margin: auto;
  }
  .main-body {
    min-width: 1300px;
  }
}
</style>
